const DefaultPartyType = Object.freeze({
  Shipper: 'SHI', Consignee: 'CON'
})

export default DefaultPartyType